import PrintPreferenceTabs from "../templete/PrintPreferenceTabs";
const SalesInvoice = () => {
  return (
    <PrintPreferenceTabs type="sales_invoice"></PrintPreferenceTabs>
  );
};
export default SalesInvoice;
